export default config => {
  let stripe;
  let elements;
  let cardElement;

  return {
    stripeFailedToInitialize: false,
    stripeValidationError: "",
    stripeInitialized: false,
    clientSecret: config.stripeClientSecret,
    processing: false,
    validated: false,
    termsAccepted: false,
    init() {
      if (this.clientSecret) {
        this.setupStripe().catch(err => {
          console.log(err);
          this.stripeFailedToInitialize = true;
        });
      }
      this.$watch("clientSecret", value => {
        if (value) {
          this.setupStripe().catch(err => {
            console.log(err);
            this.stripeFailedToInitialize = true;
          });
        }
      });
    },
    async processCard() {
      if (!this.validated) {
        return;
      }

      if (!this.termsAccepted) {
        return;
      }

      this.processing = true;

      let result;
      if (config.intentType === "setup") {
        result = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url: config.returnUrl
          },
          redirect: "if_required"
        });
      } else {
        result = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: config.returnUrl
          },
          redirect: "if_required"
        });
      }

      if (result.error) {
        this.stripeValidationError = result.error.message;
        this.processing = false;
      } else {
        const payment_method_or_setup_intent = result.setupIntent ? result.setupIntent.payment_method : result.paymentIntent.id;
        this.$wire
          .call(config.submitMethod, payment_method_or_setup_intent)
          .then(result => {
            this.processing = false;
            this.validated = false;
          }).catch(err => {
            console.log(err);
          });
      }
    },
    setupStripe() {
      if (
        !config ||
        !config.submitMethod ||
        !config.stripePublicKey ||
        !this.clientSecret ||
        !config.stripeElementId ||
        !config.stripeConnectedAccountId
      ) {
        return new Promise((resolve, reject) =>
          reject("Stripe could not be initialized.")
        );
      }

      if (this.stripeInitialized) {
        return new Promise((resolve, reject) => resolve());
      }

      if (!stripe) {
        stripe = new Stripe(config.stripePublicKey, {
          stripeAccount: config.stripeConnectedAccountId
        });
      }

      return new Promise((resolve, reject) => {
        this.processing = true;
        const options = {
          clientSecret: this.clientSecret,
          appearance: {
            variables: {
              colorBackground: '#F1F5F9'
            }
          }
        };
        elements = stripe.elements(options);
        cardElement = elements.create("payment");
        cardElement.mount("#" + config.stripeElementId);
        cardElement.on("change", event => {
          if (event.error) {
            this.stripeValidationError = event.error.message;
            this.validated = false;
            return;
          }
          this.stripeValidationError = "";
          this.validated = event.complete;
        });
        this.processing = false;
        this.stripeInitialized = true;
        resolve();
      });
    }
  };
};
